import React from 'react';
import { Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

export const WhatsAppButton = () => {
  const whatsappNumber = contactInfo.phones[0].replace(/\D/g, '');
  const message = encodeURIComponent('Hi! I am interested in your real estate services.');
  const whatsappUrl = `https://wa.me/91${whatsappNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-24 sm:bottom-24 right-6 z-50 w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 group"
    >
      <Phone className="w-6 h-6 sm:w-8 sm:h-8 transform group-hover:rotate-12 transition-transform duration-300" />
    </a>
  );
};
